var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPluginLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    fillRule: "evenodd",
    d: "M6.257 8.35h-1.5c-.7 0-1.3.3-1.8.7-.5.4-.7 1.2-.7 1.8v6.3c0 .7.3 1.3.7 1.8.4.5 1.1.7 1.8.7h1.5V8.35zM21.357 8.35c-.1-.4-.3-.7-.5-1-.2-.3-.5-.5-.9-.7-.3-.2-.7-.2-1.1-.2h-4.3v-2.7c0-.9-.4-1.8-1-2.4-.6-.6-1.5-1-2.4-1-.3-.1-.6.1-.7.3l-2.7 6v13.1h9.9c.6 0 1.2-.2 1.7-.6.5-.4.8-1 .9-1.6l1.2-8.1c0-.3 0-.7-.1-1.1z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPluginLiked);
export default __webpack_public_path__ + "static/media/icons_plugin_liked.3279b00f944d7511d9324c0cffcf1c4d.svg";
export { ForwardRef as ReactComponent };